import striptags from 'striptags';

/**
 * File Overview
 * Shared resources for data normlization.
 */

export default {
  stripDescription(description) {
    return striptags(description, ['p', 'strong', 'em', 'br', 'a']);
  }
}



// WEBPACK FOOTER //
// ./src/client/normalizers/shared.js